enum TransitType {
    BUS = '1',
    SUBWAY = '2',
    TRAM = '3',
    TRAIN = '4',
    FERRY = '7',
}

export default TransitType;
